module.exports = __webpack_public_path__ + "img/logo.b2f72064.svg";